import React from 'react'
import { Table,Space } from 'antd'
import { AiOutlineFilePdf } from "react-icons/ai";

export default function Datatable({data}) {

    console.log({data})
    const columns = [
        {
            title:"Name",
            dataIndex:"name"

        },
        {
            title:"Last Name",
            dataIndex:"last_name",
        },
        {
            title:"Phone Number",
            dataIndex:"phone_number"
        },
        {
            title:"Email",
            dataIndex:"email"
        },
        {
            title:"Department Appplied For",
            dataIndex:"department",
        },
        {
            title:"Post Applied For",
            dataIndex:"post_applying_for",
        },
        {
            title:"Resume",
            render: (record) => {
                console.log(record?.resume)
                return (
                  <Space size="middle">
                    {/* <PDFViewer
                      document={{
                        url: record?.resume,
                      }}
                    /> */}
                    <a href={record?.resume} target='_blank' style={{fontSize:'20px'}} ><AiOutlineFilePdf  /></a>
                  </Space>
                );
        }
    }

    ]
  return (
        <>
           <Table
           dataSource = {data}
           columns={columns}
           rowKey = {(record => record._id)}
           style={{overflowY:'auto', height:'77vh', overflowX:'hidden' }}
           
           >

           </Table> 
        </>
  )
}

 